<template>
  <div class="application-page">
    <form-section
      id="organization-section"
      title="Заявитель"
    >
      <organization-form-block
        v-model="organizationModel"
        :errors="errors"
        :form="form"
        :organization="{subject_id: ''}"
        :organization-subjects="[
          {id: 'individual', name: 'Индивидуальный предприниматель'},
          {id: 'entity', name: 'Юридическое лицо'}
        ]"
      />
    </form-section>

    <form-section
      id="port-call-section"
      title="Судозаход"
    >
      <template v-slot:step-icon>
        <step-icon step-number="two"/>
      </template>
      <port-call-form-block
        id="port-call"
        :errors="errors"
      />
    </form-section>
    <form-section v-if="isNew || isDuplicate"
      id="apply-application-from-block"
      title="Подача заявки"
    >
      <template v-slot:step-icon>
        <step-icon step-number="three"/>
      </template>
      <apply-application-form-block
        @draft-application="draftApplication"
        @create-application="createApplication"
      >
        <template v-slot:before>
          <application-cost
            :cost="localeApplicationCost"
          />
        </template>
      </apply-application-form-block>
    </form-section>
    <form-section v-if="showActualDateBlockEdit"
      id="actual-date-block"
      title="Фактическая дата"
    >
      <template v-slot:step-icon>
        <p></p>
      </template>
      <actual-date-block/>
    </form-section>
    <form-section v-if="isEdit"
      id="apply-application-from-block"
      title="Подача заявки"
    >
      <template v-slot:step-icon>
        <step-icon step-number="three"/>
      </template>
      <edit-application-form-block
        @edit-application="editApplication"
      />
    </form-section>
    <form-section v-if="showActualDateBlock"
      id="actual-date-block"
      title="Фактическая дата"
    >
      <template v-slot:step-icon>
        <step-icon step-number="three"/>
      </template>
      <actual-date-block>
        <template v-slot:after>
          <b-button
            variant="success"
            :disabled="false"
            @click="fixActualDate"
            style="margin-top: 29px"
          >
            Подтвердить
          </b-button>
        </template>
      </actual-date-block>
    </form-section>
  </div>
</template>

<script>
import FormSection from '@/common/components/application/FormSection'
import OrganizationFormBlock from '@/common/components/application/form-blocks/organization/OrganizationFormBlock'
import PortCallFormBlock from '@/components/application/form-blocks/vessels/PortCallFormBlock'
import StepIcon from '@/components/application/step-icons/StepIcon'
import ApplyApplicationFormBlock from '@/components/application/form-blocks/ApplyApplicationFormBlock'
import ApiClient from '@/helpers/api-client/ApiClient'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import { ApplicationTypes } from '@/common/enums/ApplicationTypes'
import { ResponseStatuses } from '@/enums/ResponseStatuses'
import applicationFormMixin from '@/common/mixins/applicationFormMixin'
import ActualDateBlock from '@/components/application/ActualDateBlock.vue'
import ApplicationCost from '@/components/application/ApplicationCost.vue'
import EditApplicationFormBlock from '@/components/application/form-blocks/EditApplicationFormBlock.vue'
import ApplicationClient from '@/common/helpers/api-client/Application'
import { UserRoles } from '@/enums/UserRoles'
import { ApplicationStatuses } from '@/enums/ApplicationStatuses'

export default {
  name: 'Application',

  components: {
    EditApplicationFormBlock,
    ApplicationCost,
    ApplyApplicationFormBlock,
    StepIcon,
    FormSection,
    OrganizationFormBlock,
    PortCallFormBlock,
    ActualDateBlock
  },

  mixins: [
    applicationFormMixin
  ],

  props: {
    appId: {
      type: String
    },
    mode: {
      type: String,
      default: () => 'create'
    }
  },

  data () {
    return {
      errors: {},
      sailTypes: [{ id: 1, name: 'Каботажное' }, { id: 2, name: 'Загранплавание' }]
    }
  },

  computed: {
    ...mapState('vtsApplication', {
      actual_date: state => state.application.actual_date,
      form: state => state,
      organization: state => state.organization
    }),

    ...mapGetters('vtsApplication', [
      'applicationCost'
    ]),

    applicationFormData () {
      return {
        application: { ...this.form.application, cost: this.applicationCost },
        organization: this.form.organization,
        vessel: { ...this.form.vessel.formData, is_new: this.form.isNewVessel },
        type: ApplicationTypes.SHIP_CALL,
        draft: false
      }
    },

    localeApplicationCost () {
      return this.numberToLocaleString(this.applicationCost)
    },

    organizationModel: {
      get () {
        return this.organization
      },

      set (value) {
        this.setOrganization(value)
      }
    },

    showActualDateBlock () {
      return this.isCheckOrView &&
        this.user.role === UserRoles.DISPATCHER &&
        this.form.application.status === ApplicationStatuses.AWAITING
    },

    showActualDateBlockEdit () {
      return this.isEdit && ApplicationStatuses.compare(ApplicationStatuses.AWAITING, this.form.application.status)
    }
  },

  created () {
    this.showPreloader()
    this.resetState()
    this.requestData()
  },

  methods: {
    ...mapMutations('vtsApplication', [
      'setOrganization',
      'resetState'
    ]),

    ...mapActions('vtsApplication', [
      'requestApplication',
      'requestExtraData'
    ]),

    createApplication (draft = false) {
      ApiClient.createApplication({
        ...this.applicationFormData, draft
      }).then((response) => {
        if (response.data.status === ResponseStatuses.Success) {
          this.resetState()
          this.showPreloader()
          this.$router.push({
            name: 'application-list'
          })
        } else {
          this.errors = response.data.errors
          this.$nextTick().then(() => this.$scrollTo('.has-error', 500, { offset: -170 }))
        }
      })
    },

    draftApplication () {
      this.createApplication(true)
    },

    editApplication () {
      ApplicationClient.editApplication({
        ...this.applicationFormData
      }).then((response) => {
        if (response.data.status === ResponseStatuses.Success) {
          this.resetState()
          this.showPreloader()
          this.$router.push({
            name: 'application-list'
          })
        } else {
          if (response.data?.errors?.alert) {
            alert(response.data.errors.alert)
          }

          this.errors = response.data.errors

          this.$nextTick().then(() => this.$scrollTo('.has-error', 500, { offset: -170 }))
        }
      })
    },

    fixActualDate () {
      ApiClient.fixApplicationActualDate({ id: this.appId, actual_date: this.actual_date }).then((response) => {
        if (response.status === 200) {
          this.$router.push({ name: 'application-list' })
        }
      })
    },

    async requestData () {
      await this.requestApplication({
        application_id: this.appId,
        access_level: this.mode
      })

      await this.requestExtraData({
        application_id: this.appId,
        access_level: this.mode
      })

      this.hidePreloader()
    }
  }
}
</script>
